export const MaximumRecordsCount = {
  locations: '500k',
  addresses: '1000',
  polygons: '1000',
};
